import * as React from 'react';
import * as styles from './styles.css';

import { Sticky } from '../packages/Sticky';

interface IPageAsideProps {
  children: React.ReactNode;
}

export const PageAside: React.FC<IPageAsideProps> = ({ children }) => {
  /**
   * Идея shrinkable_gap в том, что между контентом и моталкой на странице должен быть сжимаемый промежуток
   * а сама моталка при этом не сжимается
   * */
  return (
    <Sticky top={20} rootClassName={styles['page_aside']}>
      <div className={styles['flex']}>
        <div className={styles['shrinkable_gap']} />
        <div className={styles['content']}>{children}</div>
      </div>
    </Sticky>
  );
};

PageAside.displayName = 'PageAside';
